import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ArtistCell.style';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { deleteArtist } from 'redux/actions/Artist';
import useSwalWrapper from '@jumbo/vendors/sweetalet2/hook';

const ArtistItemCell = ({ artist }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const Swal = useSwalWrapper();

  const { name, family, id } = artist;

  const handleDelete = () => {
    Swal.fire({
      title: `آیا از حذف ${name} ${family} مطمعن هستید؟`,
      icon: 'warning',
      iconHtml: '؟',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'حذف',
      cancelButtonText: 'لغو',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => dispatch(deleteArtist(id)),
    });
  };

  const handleGoToUpdate = () => {};

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Typography className={classes.titleRoot} component="div" variant="h4">
            {name} {family}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot} style={{ textAlign: 'end' }}>
        <Tooltip title="ویرایش">
          <IconButton size="small" target="_blank" onClick={handleGoToUpdate}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="حذف">
          <IconButton size="small" target="_blank" onClick={handleDelete}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default ArtistItemCell;

ArtistItemCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
